










































































































































































































import { Component, Vue } from "vue-property-decorator";
import AccountingSystem from "@/data/AccountingSystem";
import MatchSubjectVue from "@/components/DataImport/MatchSubject.vue";

@Component({
    components: {
        "match-subject": MatchSubjectVue
    }
})
export default class DataImport extends Vue {
    appList = [
        {
            id: 1,
            name: "柠檬云",
            initName: "科目余额表",
            voucherName: "凭证列表"
        },
        {
            id: 2,
            name: "易代账",
            initName: "科目期初",
            voucherName: "凭证列表"
        },
        {
            id: 3,
            name: "云代账",
            initName: "财务初始余额",
            voucherName: "凭证列表"
        },
        {
            id: 4,
            name: "云账房",
            initName: "科目余额表",
            voucherName: "凭证列表"
        },
        {
            id: 17,
            name: "唯易",
            initName: "科目余额表",
            voucherName: "凭证列表"
        },
        {
            id: 18,
            name: "大账房",
            initName: "科目余额表",
            voucherName: "凭证列表"
        },
        {
            id: 21,
            name: "诺诺云代账",
            initName: "科目期初",
            voucherName: "凭证列表"
        },
        {
            id: 5,
            name: "芸豆",
            initName: "科目余额表",
            voucherName: "序时账"
        },
        {
            id: 6,
            name: "账无忧",
            initName: "财务初始余额",
            voucherName: "凭证列表"
        },
        {
            id: 7,
            name: "亿企代账",
            initName: "科目余额表",
            voucherName: "序时账"
        },
        {
            id: 8,
            name: "企账宝",
            initName: "科目期初",
            voucherName: "凭证列表"
        },
        {
            id: 9,
            name: "金财代账",
            initName: "科目期初",
            voucherName: "凭证列表"
        },
        {
            id: 12,
            name: "迅兔财务软件",
            initName: "科目余额表",
            voucherName: "序时账"
        },
        {
            id: 13,
            name: "航天信息-Aisino A6",
            initName: "科目余额表",
            voucherName: "凭证列表"
        },
        {
            id: 14,
            name: "速达3000",
            initName: "科目余额表",
            voucherName: "序时账"
        },
        {
            id: 15,
            name: "金蝶专业版",
            initName: "科目余额表",
            voucherName: "序时账"
        },
        {
            id: 19,
            name: "企明星",
            initName: "科目余额表",
            voucherName: "凭证列表"
        },        {
            id: 20,
            name: "润茂财税",
            initName: "科目余额表",
            voucherName: "凭证列表"
        },
        {
            id: 10,
            name: "账套迁移软件",
            initName: "选择数据包",
            // voucherName: "凭证列表"
        },
        {
            id: 11,
            name: "账套迁移软件2.0",
            initName: "选择数据包",
            // voucherName: "凭证列表"
        },
        {
            id: 16,
            name: "新版账套迁移软件3.0",
            initName: "选择数据包",
            // voucherName: "凭证列表"
        }
    ];

    keys = {
        oldImportType: this.appList[0].id,
        addtax: "",
        startPeriod: "",
        accountingSystem: AccountingSystem.thirteenRule,
        bookName: ""
    }

    bookInfo = {
        initBalanceNum: "",
        unMatchSubjectNum: "",
        voucherNum: "",
        voucherRecordNum: "",
        dimAccount: ""
    }

    systemList = AccountingSystem;

    initBalance: File | null = null;
    voucher: File | null = null;

    formData = new FormData();
    searchKey = "";

    matchVisible = false;
    importDisabled = true;

    get uploadDisabled() {
        return (this.keys.accountingSystem !== AccountingSystem.npo ? (this.keys.addtax === "" || this.keys.addtax === null) : false) || (this.keys.startPeriod === "" || this.keys.startPeriod === null) || this.keys.bookName === "" || (this.initBalance === null && this.voucher === null);
    }

    showTip = false;

    voucherMinPeriod = "2100-10-10";
    get showPeriodTip() {
        return (this.keys.startPeriod !== "" && new Date(this.voucherMinPeriod) < new Date(this.keys.startPeriod))
    }

    get importTypeObj() {
        for (let i = 0; i < this.appList.length; i++) {
            if (this.appList[i].id === this.keys.oldImportType) return this.appList[i];
        }
        return this.appList[0];
    }

    afterChange() {
        if (this.searchKey !== "" && !this.uploadDisabled) {
            this.showTip = true;
        }
    }

    selectInit(e: { target: { files: FileList } }) {
        // this.formData.delete("initBalance");
        const file = e.target.files[0];
        this.initBalance = file;
        if(this.keys.oldImportType === 16) {
            this.keys.bookName = e.target.files[0].name.split("_")[0]
            this.keys.startPeriod = e.target.files[0].name.split("_")[1].substring(0,4) + "-" + e.target.files[0].name.split("_")[1].substring(4,6)
        }
        this.afterChange();
        // this.formData.append("initBalance", file);
    }
    selectVoucher(e: { target: { files: FileList } }) {
        // this.formData.delete("voucher");
        const file = e.target.files[0];
        this.voucher = file;
        this.afterChange();
        // this.formData.append("voucher", file);
    }

    async upload() {
        this.formData = new FormData();
        Object.keys(this.keys).forEach(e => {
            this.formData.append(e, (<any>this.keys)[e]);
        });
        if(this.importTypeObj.id !=10 && this.importTypeObj.id !=11 && this.importTypeObj.id !=16){
            this.formData.append("initBalance", <File>this.initBalance);
            this.formData.append("voucher", <File>this.voucher);
        }else {
            this.formData.append("file", <File>this.initBalance);
        }
        this.formData.append("key", this.searchKey);
        const res = await Vue.axios.post("old/import/upload", this.formData);
        this.importDisabled = res.data.unMatchSubjectNum !== 0;
        Object.keys(this.bookInfo).forEach(e => {
            (<any>this.bookInfo)[e] = res.data[e];
        });
        this.searchKey = res.data.key;
        // this.$message(res.data.message);
        if(res.data.message) {
            this.$msgbox({
            message: res.data.message,
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: false,
        });
        }
        this.showTip = false;
        const response = await Vue.axios.get(`old/import/data?key=${this.searchKey}`);
        if (response.data.voucherMinPeriod !== null) this.voucherMinPeriod = response.data.voucherMinPeriod;
        console.log(response.data.voucherMinPeriod)
    }

    matchSuccess() {
        let matchSubject: any = this.$refs.matchSubject;
        this.bookInfo.unMatchSubjectNum = matchSubject.oldSubjectList.length;
        if (matchSubject.oldSubjectList.length == 0) {
            // this.finishButton = true;
            this.importDisabled = false;
        } else {
            this.$alert("亲，您还有科目没有匹配完成！");
            // this.finishButton = false;
            this.importDisabled = true;
        }
    }

    clearData() {
        this.keys = {
            oldImportType: this.appList[0].id,
            addtax: "",
            startPeriod: "",
            accountingSystem: AccountingSystem.thirteenRule,
            bookName: ""
        }

        this.bookInfo = {
            initBalanceNum: "",
            unMatchSubjectNum: "",
            voucherNum: "",
            voucherRecordNum: "",
            dimAccount: ""
        }

        this.formData = new FormData();
        this.searchKey = "";
        this.importDisabled = true;
        this.clearInit();
        this.clearVoucher();
    }

    async importData() {
        const response = await Vue.axios.post(`old/import/bookData?key=${this.searchKey}&accounterId=${this.$store.state.account.id}`, {}, { timeout: 1000 * 60 * 10 });
        try {
            await this.$msgbox.confirm("成功导入 " + this.keys.bookName + "，点击确认进入账套，点击取消返回界面继续导入", {});
            this.$store.dispatch("changeCurrentIcon", "记账");
            await Vue.axios.post(`accountbooks/` + response.data).then(res => {
                this.$store.dispatch("changeAccounBook", res.data);
                this.$utils.setTaxType(res.data);
                this.$utils.getRemarks();
                this.$router.push("/voucherlist");
            });
        } catch (e) {
            this.clearData();
        }
    }

    clearInit() {
        this.initBalance = null;
        const input = <HTMLInputElement>document.querySelector(".init-file");
        input.value = "";
        this.afterChange();
    }
    clearVoucher() {
        this.voucher = null;
        const input = <HTMLInputElement>document.querySelector(".voucher-file");
        input.value = "";
        this.afterChange();
    }
}
